import { useState, type FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const honeypotInput = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypotInput && honeypotInput.value.trim() !== '') {
      setStatus('success');
      setMessage('感谢订阅！');
      setEmail('');
      return;
    }

    setStatus('loading');
    setMessage('');

    try {
      const formData = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d9u23278l97n3eas3fs0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse error
      }

      if (response.ok && parsed && (parsed as Record<string, unknown>).code === 'OK') {
        setStatus('success');
        setMessage('感谢订阅！我们会定期发送最新研究资讯到您的邮箱。');
        setEmail('');
      } else {
        const serverMsg =
          (parsed as Record<string, unknown>)?.meta &&
          typeof (parsed as Record<string, unknown>).meta === 'object'
            ? ((parsed as Record<string, unknown>).meta as Record<string, string>).message || ''
            : '';
        if (serverMsg && serverMsg.includes('spam')) {
          setStatus('error');
          setMessage('提交失败，请稍后再试。');
        } else {
          setStatus('error');
          setMessage(serverMsg || '订阅失败，请稍后再试。');
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查连接后重试。');
    }
  };

  return (
    <section className="py-16 md:py-20 bg-primary-500">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
          订阅研究资讯
        </h2>
        <p className="text-background-50/80 text-sm md:text-base mb-8">
          获取最新的援助交配现象研究成果、学术动态与深度分析文章
        </p>

        <form
          id="newsletter-form"
          data-readdy-form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="text"
            name="website_alt"
            className="honeypot-field"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 px-5 py-3 rounded-lg bg-background-50 text-foreground-900 text-sm placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-background-50/50"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-6 py-3 rounded-lg bg-foreground-950 text-background-50 font-medium text-sm hover:bg-foreground-900 transition-colors duration-200 whitespace-nowrap disabled:opacity-60"
          >
            {status === 'loading' ? (
              <span className="flex items-center gap-2">
                <i className="ri-loader-4-line animate-spin"></i>
                提交中
              </span>
            ) : (
              '立即订阅'
            )}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-sm text-background-50/90">{message}</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-background-50/90">{message}</p>
        )}
      </div>
    </section>
  );
}